import React from 'react';
import cx from '../utils/cx';
import ui from '../styles/primitives.module.css';

const OVERLAYS = {
  default: undefined,
  hero: ui.overlayHero,
  soft: ui.overlaySoft,
};

// Full-bleed section with a photo background, tinted overlay and gold hairline.
const Section = ({ id, background, backgroundPosition, overlay = 'default', className, children }) => (
  <section
    id={id}
    className={cx(ui.section, OVERLAYS[overlay], className)}
    style={background ? { backgroundImage: `url(${background})`, backgroundPosition } : undefined}
  >
    {children}
  </section>
);

export default Section;
